<template lang="pug">
  .container.grid-xl
    page-title(icon="fas fa-user" :title="title" :subtitle="subtitle")
    .flex-centered.full-height(v-if="error") #[error-box(:error="error")]
    fieldset(v-else :disabled="loading")
      .columns.pb-2
        .column.col-6.col-lg-7.col-md-8.col-sm-12
          form(@submit.prevent="onSubmit")
            .card
              .card-header
                .card-title.h5 Dados do usuário
              .card-body
                .columns
                  .column.col-12
                    form-group(label="Nome completo" :validation="$v.personForm.person" field="fullName")
                      input.form-input(v-model.trim="$v.personForm.person.fullName.$model")
                  .column.col-12
                    form-group(label="E-mail" :validation="$v.personForm.person" field="email")
                      input.form-input(type="email" v-model.trim="$v.personForm.person.email.$model")
                  .column.col-6.col-sm-12
                    form-group(label="Telefone" :validation="$v.personForm.person" field="phoneNumber")
                      the-mask.form-input(:mask="['## ####-####', '## #####-####', '+## ## ####-####', '+## ## #####-####']" v-model="$v.personForm.person.phoneNumber.$model")
                  .column.col-6.col-sm-12
                    form-group(label="Documento" :validation="$v.personForm.person" field="documentNumber")
                      input.form-input(v-model="$v.personForm.person.documentNumber.$model")
                  .column.col-12.divider
                  .column.col-12
                    form-group(label="Avatar" :validation="$v.personForm.person" field="photoURL")
                      file-upload(v-model="$v.personForm.person.photoURL.$model")
                  .column.col-12.divider
                  .column.col-6.col-sm-12
                    form-group(label="Senha" :validation="$v.personForm.person" field="password")
                      input.form-input(type="password" v-model="$v.personForm.person.password.$model")
                  .column.col-6.col-sm-12
                    form-group(label="Confirme a senha")
                      input.form-input(type="password" v-model="$v.personForm.passwordConfirmation.$model")
                  .divider.col-12
                  .column.col-12
                    form-switch(v-model="$v.personForm.person.admin.$model" label="É um administrador")
                  .divider.col-12
              .card-footer.text-right
                button.btn.btn-primary(:disabled="disabledPerson") Salvar
      .columns.mt-2(v-if="personForm.person.id")
        .column.col-6.col-lg-7.col-md-8.col-sm-12
          form(@submit.prevent="onSubmitAddress")
            .card
              .card-header
                .card-title.h5 Endereço
              .card-body
                .columns
                  .column.col-4.col-sm-12
                    form-group(label="Cep" :validation="$v.address" field="zipCode")
                      zipcode-input.form-input(v-model="$v.address.zipCode.$model" :ignore-first="Boolean(address.id)" @zipcode-founded="onZipCodeFounded")
                  .column.col-6.col-sm-12
                    form-group(label="Cidade" :validation="$v.address" field="city")
                      input.form-input(v-model="$v.address.city.$model" disabled)
                  .column.col-2.col-sm-12
                    form-group(label="UF" :validation="$v.address.state" field="code")
                      input.form-input(v-model="$v.address.state.code.$model" disabled)
                  .column.col-10.col-sm-12
                    form-group(label="Logradouro" :validation="$v.address" field="street")
                      input.form-input(v-model="$v.address.street.$model")
                  .column.col-2.col-sm-12
                    form-group(label="Número" :validation="$v.address" field="number")
                      input.form-input(v-model="$v.address.number.$model")
                  .column.col-8.col-sm-12
                    form-group(label="Bairro" :validation="$v.address" field="neighborhood")
                      input.form-input(v-model="$v.address.neighborhood.$model")
                  .column.col-4.col-sm-12
                    form-group(label="Complemento" :validation="$v.address" field="complement")
                      input.form-input(v-model="$v.address.complement.$model")
              .card-footer.text-right
                button.btn.btn-primary(:disabled="disabledAddress") Salvar
    subscriptions(v-if="this.$route.params.id")
</template>

<script>
import {
  required,
  requiredIf,
  email,
  sameAs,
  minLength,
} from 'vuelidate/lib/validators'
import people from '@/services/people'
import address from '@/services/address'
import sanitizeBody from '@/lib/sanitizeBody'
import subscriptions from '@/views/users/components/subscriptions'

export default {
  data() {
    return {
      loading: false,
      error: null,
      personForm: {
        person: {
          email: '',
          fullName: '',
          password: '',
          photoURL: '',
          phoneNumber: '',
          documentNumber: '',
          admin: false,
        },
        passwordConfirmation: '',
      },
      address: {
        zipCode: '',
        city: '',
        district: '',
        neighborhood: '',
        street: '',
        number: '',
        complement: '',
        state: { code: '' },
      },
    }
  },
  validations: {
    personForm: {
      person: {
        id: {},
        email: { required, email },
        fullName: { required },
        password: { required: requiredIf(nested => !nested.id) },
        admin: { required },
        address: {},
        photoURL: {},
        phoneNumber: {},
        documentNumber: {},
      },
      passwordConfirmation: {
        sameAs: sameAs(nested => {
          return nested.person.password ? nested.person.password : ''
        }),
      },
    },
    address: {
      zipCode: { required, minLength: minLength(8) },
      city: { required },
      district: {},
      neighborhood: { required },
      street: { required },
      number: { required },
      complement: {},
      state: { code: { required } },
    },
  },
  computed: {
    title() {
      return this.$route.params.id ? 'Editar usuário' : 'Novo usuário'
    },
    subtitle() {
      return 'Esse usuário poderá se autenticar no Acervo'
    },
    disabledPerson() {
      return this.loading || this.$v.personForm.$invalid
    },
    disabledAddress() {
      return this.loading || this.$v.address.$invalid
    },
    body() {
      return sanitizeBody(this.person)
    },
  },
  methods: {
    async onSubmit() {
      const body = this.personForm.person
      const submitFunction = body.id ? people.update : people.create
      try {
        this.loading = true
        await submitFunction(body)
        this.$toaster.success('Usuário salvo')
      } catch (e) {
        this.$toaster.error('Não foi possível salvar o usuário')
      } finally {
        this.loading = false
      }
    },
    async onSubmitAddress() {
      try {
        this.loading = true
        const { data } = await address.createOrUpdate({
          ...this.address,
          person: { id: this.personForm.person.id },
        })
        this.address = data
        this.$toaster.success('Endereço atualizado')
      } catch (e) {
        this.$toaster.error('Não foi possível alterar o endereço')
      } finally {
        this.loading = false
      }
    },
    onZipCodeFounded(address) {
      this.address = { ...this.address, ...address }
    },
  },
  async mounted() {
    if (!this.$route.params.id) return
    try {
      this.loading = true
      const { data } = await people.show(this.$route.params.id)
      const { address, ...person } = data
      this.personForm.person = person
      if (address) this.address = address
    } catch (e) {
      this.error = e
    } finally {
      this.loading = false
    }
  },
  components: { subscriptions },
}
</script>
